<ng-container *ngIf="status | async as status">
  <div class="further-qualification-progress-widget-container">
    <div class="progress-container">
      <div class="progress-container-content">
        <p
          *ngIf="!status.adminVerified && !status.approvedByBackoffice"
          class="progress"
        >
          {{
            'platformWidget.furtherQualification.progress.progress50'
              | transloco
          }}
        </p>
        <p
          *ngIf="status.adminVerified || status.approvedByBackoffice"
          class="progress"
        >
          {{
            'platformWidget.furtherQualification.progress.progress75'
              | transloco
          }}
        </p>
        <span class="progress-text">{{
          'platformWidget.furtherQualification.progress.progressText'
            | transloco
        }}</span>
      </div>
    </div>

    <markant-seperator
      class="separator"
      orientation="vertical"
    ></markant-seperator>

    <div class="phase">
      <div class="phase-content">
        <markant-icon icon="m_checkmark" color-scheme="success"></markant-icon>
        <span class="success-content">{{
          'platformWidget.furtherQualification.progress.phase1' | transloco
        }}</span>
      </div>
      <div class="phase-content">
        <markant-icon icon="m_checkmark" color-scheme="success"></markant-icon>
        <span class="success-content">{{
          'platformWidget.furtherQualification.progress.phase2' | transloco
        }}</span>
      </div>
      <div class="phase-content">
        <markant-icon
          *ngIf="!status.adminVerified"
          icon="m_arrow-up"
          class="in-progress"
          style="transform: rotate(90deg)"
        ></markant-icon>
        <markant-icon
          *ngIf="status.adminVerified"
          icon="m_checkmark"
          color-scheme="success"
        ></markant-icon>
        <span
          [className]="status.adminVerified ? 'success-content' : 'in-progress'"
          >{{
            'platformWidget.furtherQualification.progress.phase3' | transloco
          }}</span
        >
      </div>
      <div class="phase-content">
        <markant-icon
          *ngIf="!status.approvedByBackoffice"
          icon="m_arrow-up"
          class="in-progress"
          style="transform: rotate(90deg)"
        ></markant-icon>
        <markant-icon
          *ngIf="status.approvedByBackoffice"
          icon="m_checkmark"
          color-scheme="success"
        ></markant-icon>
        <span
          [className]="
            status.approvedByBackoffice ? 'success-content' : 'in-progress'
          "
          >{{
            'platformWidget.furtherQualification.progress.phase4' | transloco
          }}</span
        >
      </div>
    </div>
  </div>
</ng-container>
